import router from "@/router";
import { setCustomAttribute } from "@/api/logging";
import agent from "@/utils/newrelic";

router.afterEach(() => {
  agent.setCustomAttribute("urlHash", window.location.hash);
  agent.setCurrentRouteName(window.location.hash);
  setCustomAttribute("urlHash", window.location.hash);
});
